<div class="tour-popover-container" *ngIf="isBrowser && tourState && tourState.isActive">
  <!-- Blocking overlay - prevents clicks outside the popover (unless allowBackgroundInteraction is true) -->
  <div class="tour-blocking-overlay" *ngIf="!tourState.currentStep?.allowBackgroundInteraction"></div>
  
  <!-- Tour Popover - Floats over content -->
  <div class="demo-popover" 
       [class]="getArrowClasses()"
       [class.positioning]="isPositioningPopover"
       [ngStyle]="{
         'top.px': popoverPosition.top,
         'left.px': popoverPosition.left,
         'right.px': popoverPosition.right,
         'bottom.px': popoverPosition.bottom,
         'transform': popoverPosition.transform,
         '--arrow-offset': arrowPosition?.offsetPercent != null ? arrowPosition!.offsetPercent + '%' : '50%'
       }">
    
    <!-- Tour Selection Screen -->
    <div class="tour-selection" *ngIf="!tourState.currentStep">
      <div class="tour-selection-header">
        <div class="tour-selection-header-content">
          <i class="fa-solid fa-route tour-selection-icon"></i>
          <h2 class="tour-selection-title">Tours</h2>
          <p class="tour-selection-subtitle">Choose a guided tour to get started</p>
        </div>
        <button class="tour-selection-close-btn" (click)="onClose()" title="Close">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      <div class="tour-list">
        <button 
          *ngFor="let tour of availableTours"
          class="tour-card"
          [class.completed]="isTourCompleted(tour.id)"
          (click)="startTour(tour.id)">
          <div class="tour-card-completion">
            <div class="completion-circle" [class.completed]="isTourCompleted(tour.id)">
              <i *ngIf="isTourCompleted(tour.id)" class="fa-solid fa-check"></i>
            </div>
          </div>
          <div class="tour-card-content">
            <h3 class="tour-card-title">{{ tour.name }}</h3>
            <p class="tour-card-description">
              {{ tour.description }}
              <span class="tour-card-time" *ngIf="tour.estimatedMinutes">
                <i class="fa-solid fa-clock"></i> {{ tour.estimatedMinutes }} min
              </span>
            </p>
          </div>
          <div class="tour-card-arrow">
            <i class="fa-solid fa-arrow-right"></i>
          </div>
        </button>
      </div>
    </div>

    <!-- Active Tour Display -->
    <div class="tour-active" *ngIf="tourState.currentStep">
      <!-- Header -->
      <div class="tour-header">
        <div class="tour-title">
          <i [class]="tourState.tour?.icon || 'fa-solid fa-map'" class="tour-icon"></i>
          <div class="tour-title-content">
            <span class="tour-name">{{ tourState.tour?.name }}</span>
            <span class="tour-progress-text">{{ getProgressText() }}</span>
          </div>
        </div>
        <div class="tour-header-actions">
          <!-- <button class="tour-reset-btn" 
                  *ngIf="tourState.tour?.id && isTourCompleted(tourState.tour?.id!)"
                  (click)="onReset()" 
                  title="Reset Tour Progress">
            <i class="fa-solid fa-trash"></i>
          </button> -->
          <button class="tour-close-btn" (click)="onClose()" title="Close Tour">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Body Content -->
      <div class="tour-body">
        <!-- Step Title -->
        <h2 class="tour-step-title">{{ tourState.currentStep.title }}</h2>

        <!-- Step Content -->
        <div class="tour-step-content" [innerHTML]="tourState.currentStep.content"></div>

        <!-- Video Player (if present) -->
        <div class="tour-video-container" *ngIf="tourState.currentStep?.videoUrl">
          <video #videoPlayer controls class="tour-video"
                 (loadedmetadata)="onVideoMetadataLoaded()">
            <source [src]="tourState.currentStep?.videoUrl" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          <div class="tour-video-controls">
            <button class="video-speed-btn" (click)="changeSpeed(-0.25)" [disabled]="currentPlaybackSpeed <= 0.25">
              <i class="fa-solid fa-minus"></i>
            </button>
            <span class="video-speed-label">{{ currentPlaybackSpeed.toFixed(2) }}x</span>
            <button class="video-speed-btn" (click)="changeSpeed(0.25)" [disabled]="currentPlaybackSpeed >= 4">
              <i class="fa-solid fa-plus"></i>
            </button>
          </div>
        </div>

        <!-- Form Select Options (if present) -->
        <div class="tour-options" *ngIf="isFormSelectNavigation()">
          <div class="tour-option-grid">
            <button 
              *ngFor="let option of getNavigationOptions()"
              class="tour-option-btn"
              (click)="onSelectOption(option.id)">
              <i *ngIf="option.icon" [class]="option.icon" class="option-icon"></i>
              <span class="option-label">{{ option.label }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Footer Navigation -->
      <div class="tour-footer">
        <div class="tour-footer-buttons">
          <button 
            *ngIf="isPreviousEnabled()"
            class="tour-btn tour-btn-secondary"
            [disabled]="isExecutingActions"
            (click)="onPrevious()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <button 
            *ngIf="isButtonNavigation()"
            class="tour-btn tour-btn-primary"
            [disabled]="isExecutingActions"
            (click)="onNext()">
            <i class="fa-solid fa-circle-notch fa-spin" *ngIf="showLoader"></i>
            <span>{{ isLastStep() ? 'Finish' : 'Next' }}</span>
            <i class="fa-solid fa-arrow-right" *ngIf="!isLastStep() && !showLoader"></i>
            <i class="fa-solid fa-check" *ngIf="isLastStep() && !showLoader"></i>
          </button>
        </div>
        
        <!-- Progress Bar -->
        <div class="tour-progress-bar">
          <div class="tour-progress-fill" [style.width.%]="progressPercentage"></div>
        </div>
      </div>
    </div>
  </div>
</div>
